import {useCallback} from "react";
import {Query, useIsFetching, useQueryClient} from "react-query";
import useInterval from "../../../../Shared/Hooks/useInterval";

export const DAILY_REPORT_REFRESH_QUERY_KEYS: readonly string[] = [
    "daily-report",
    "daily-report-totalizers",
    "daily-report-performance-chart",
];

const isDailyReportQuery = (query: Query) => DAILY_REPORT_REFRESH_QUERY_KEYS.includes(String(query.queryKey[0]));

/**
 * Atualiza grid, totalizadores e gráfico do Diário de Operação na taxa de atualização de alarmes.
 * Invalida as queries ativas com a mesma key, então os dados atuais permanecem na tela
 * (sem skeleton) até a resposta chegar.
 * O intervalo recomeça sempre que uma dessas queries termina de buscar (troca de data, filtro
 * ou página), como na tela de Alarmes, para não disparar um refresh logo após uma busca.
 */
export function useDailyReportAutoRefresh(enabled: boolean, intervalMs: number) {
    const queryClient = useQueryClient();
    const isFetching = useIsFetching({predicate: isDailyReportQuery}) > 0;

    const refresh = useCallback(() => {
        if (!enabled) return;
        DAILY_REPORT_REFRESH_QUERY_KEYS.forEach((key) => {
            queryClient.invalidateQueries([key]);
        });
    }, [enabled, queryClient]);

    useInterval(refresh, intervalMs, undefined, isFetching);
}
